module.exports = __webpack_public_path__ + "img/advantage3Orange.940f29dd.png";